import styled from 'styled-components';
import { Button } from '@lux/buttons';
export const SubscribeButton = styled(Button) `
    margin: 32px 0 20px;
`;
//# sourceMappingURL=styles.js.map